function dateNow() {
  return Date().toLocaleString();
}

function innerWidth() {
  return window.innerWidth;
}

function innerHeight() {
  return window.innerHeight;
}

function outerWidth() {
  return window.outerWidth;
}

function outerHeight() {
  return window.outerHeight;
}

function screenWidth() {
  return window.screen.width;
}

function screenHeight() {
  return window.screen.height;
}

function screenColorDepth() {
  return window.screen.colorDepth;
}

function devicePixelRatio() {
  return window.devicePixelRatio;
}

function platform() {
  return window.navigator.platform;
}

function navigatorPlugins() {
  const plugins = [].slice.call(window.navigator.plugins).map(plugin => ({
    filename: plugin.filename,
    name: plugin.name,
  }));

  return plugins;
}

function language() {
  return window.navigator.language;
}

function cookieEnabled() {
  return window.navigator.cookieEnabled;
}

function browerContext() {
  return {
    cookies_enabled: cookieEnabled(),
    date_now: dateNow(),
    device_pixel_ratio: devicePixelRatio(),
    inner_height: innerHeight(),
    inner_width: innerWidth(),
    language: language(),
    navigator_plugins: navigatorPlugins(),
    outer_height: outerHeight(),
    outer_width: outerWidth(),
    platform: platform(),
    screen_color_depth: screenColorDepth(),
    screen_height: screenHeight(),
    screen_width: screenWidth(),
  };
}

export default browerContext;
